import axios from 'axios';

// Super Admin API - use same origin as frontend
const API_BASE_URL = process.env.REACT_APP_ADMIN_API_URL || 
  (window.location.hostname === 'localhost' 
    ? 'http://localhost:8000/admin/api/v1'
    : `${window.location.origin}/admin/api/v1`);

const adminApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Add token to requests
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      window.location.href = '/#/super-admin/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) => 
  adminApi.post('/login', { email, password });

export const logout = () => 
  adminApi.post('/logout');

export const getUser = () => 
  adminApi.get('/user');

// Statistics
export const getStatistics = () => 
  adminApi.get('/statistics');

// Tenants
export const getTenants = (params = {}) => 
  adminApi.get('/tenants', { params });

export const getTenant = (id) => 
  adminApi.get(`/tenants/${id}`);

export const createTenant = (data) => 
  adminApi.post('/tenants', data);

export const updateTenant = (id, data) => 
  adminApi.put(`/tenants/${id}`, data);

export const deleteTenant = (id) => 
  adminApi.delete(`/tenants/${id}`);

export const suspendTenant = (id, reason) => 
  adminApi.post(`/tenants/${id}/suspend`, { reason });

export const reactivateTenant = (id) => 
  adminApi.post(`/tenants/${id}/reactivate`);

export const upgradePlan = (id, plan) => 
  adminApi.post(`/tenants/${id}/upgrade-plan`, { plan });

export const getOrderStats = (id) => 
  adminApi.get(`/tenants/${id}/order-stats`);

export const clearCashOrders = (id) => 
  adminApi.post(`/tenants/${id}/clear-cash-orders`);

export const clearCardOrders = (id) => 
  adminApi.post(`/tenants/${id}/clear-card-orders`);

// Admin Users
export const getAdminUsers = () => 
  adminApi.get('/admin-users');

export const createAdminUser = (data) => 
  adminApi.post('/admin-users', data);

export const updateAdminUser = (id, data) => 
  adminApi.put(`/admin-users/${id}`, data);

export const deleteAdminUser = (id) => 
  adminApi.delete(`/admin-users/${id}`);

export default adminApi;
